// src/models/geral/Usuario.ts
export class Usuario {
  id: number;
  nome: string;
  login: string;
  senha: string;
  email: string;
  telefone: string;
  somenteTerminal: boolean;

  constructor(
      id: number = 0,
      nome: string = "", 
      login: string = "", 
      senha: string = "", 
      email: string = "", 
      telefone: string = "",
      somenteTerminal: boolean = false
  ) {
      this.id = id;
      this.nome = nome;
      this.login = login;
      this.senha = senha;
      this.email = email;
      this.telefone = telefone;
      this.somenteTerminal = somenteTerminal;
  }
}
